<div class="special-offer-insight-container">
    <div class="content-container mt-4">
        <div class="row">
            <div class="col-lg-8 mb-3 mb-lg-0">
                <div class="card analytics-card d-flex flex-grow-1">
                    <ng-container *ngIf="chartDataLoaded;
                        else contractsChartLoading">
                        <div class="d-flex flex-column flex-grow-1">
                            <div class="section-title text-secondary fw-semibold mb-3">
                                {{'specialOffers.preview.insights.chartTitle' | translate}}
                            </div>
                            <div class="insights-wrap-box d-grid gap-5 px-4">
                                <div class="insights-chart-box">         
                                    <apx-chart
                                        HJSuppress 
                                        #chartContract 
                                        [series]="chartOptions.series" 
                                        [chart]="chartOptions.chart" 
                                        [plotOptions]="chartOptions.plotOptions"
                                        [fill]="chartOptions.fill" 
                                        [stroke]="chartOptions.stroke" 
                                        [labels]="chartOptions.labels" 
                                        [states]="chartOptions.states">
                                    </apx-chart>
                                </div>
                                <div class="insights-detail-box d-flex flex-column justify-content-center gap-3">
                                    <div>
                                        <div HJSuppress class="offer-title fw-bold">{{ specialOfferInsight.campaignTitle }}</div>
                                        <div class="text-secondary">
                                            <span HJSuppress class="fw-semibold text">{{ specialOfferInsight.daysCampaignActive}}
                                                {{'specialOffers.preview.insights.daysCampaignActiveLabel' | translate}}
                                            </span>{{'specialOffers.preview.insights.daysCampaignActiveDetails' | translate}}
                                        </div>   
                                    </div> 
                                    <div class="d-flex gap-1">
                                        <div HJSuppress class="detail-count fw-bold text-primary fs-4">
                                            {{ specialOfferInsight.campaignViewCount }}
                                        </div> 
                                        <div class="fs-5">{{'specialOffers.preview.insights.userInfoNew' | translate}}</div> 
                                    </div>
                                    <div class="d-flex gap-1 ">
                                        <div HJSuppress class="detail-count fw-bold text-primary fs-4">
                                            {{ specialOfferInsight.leadsWithinSixMonthOfContractValidity }}
                                        </div> 
                                        <div class="fs-5">{{'specialOffers.preview.insights.userInfo' | translate}}</div> 
                                    </div>
                                </div>
                                <div class="insights-legend-box">
                                    <div class="legend-item gap-2">
                                        <span class="chart-legend-dot legend-info-box"></span>
                                        <span class="chart-legend-text text-secondary fw-semibold">
                                            {{'specialOffers.preview.insights.infoRequest' | translate}}
                                        </span>
                                    </div>
                                    <div class="legend-item gap-2">
                                        <span class="chart-legend-dot legend-views-box"></span>
                                        <span class="chart-legend-text text-secondary fw-semibold">
                                            {{'specialOffers.preview.insights.infoViews' | translate}}    
                                        </span>
                                    </div>
                                </div> 
                            </div>    
                        </div>
                    </ng-container>
                    <ng-template #contractsChartLoading>
                        <span>{{'specialOffers.preview.insights.chartDataLoading' | translate}}</span>
                    </ng-template>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card leads-card d-flex flex-column flex-grow-1">
                    <div class="leads-header d-flex justify-content-between align-items-center mb-3">
                        <div class="d-flex flex-column">                        
                            <div class="text-secondary fw-semibold">
                                <span>{{'specialOffers.preview.insights.leadsTitle' | translate}}</span>
                            </div>
                            <div class="leads-subtitle text-secondary">
                                <span>{{'specialOffers.preview.insights.leadsSubtitle' | translate}}</span>
                            </div>
                        </div>
                        <div class="header-buttons-box">
                            <button class="btn m-outline-btn"
                                (click)="exportToXls()" [disabled]="loading">
                                <i class="app-icon icon icon-file-excel icon-lg"></i>
                                {{'specialOffers.preview.insights.exportXLS' | translate | titlecase}}
                            </button>
                        </div>
                    </div>
                    <div class="d-flex flex-column gap-2">
                        <div *ngFor="let lead of specialOfferInsight?.leads" class="lead-item">
                            <div class="d-flex align-items-center">
                                <app-user-badge
                                    HJSuppress 
                                    [username]="lead.lastName +' '+ lead.firstName"
                                    [height]="45"
                                    [width]="45"
                                    [fontSize]="'16px'">
                                </app-user-badge>
                                <div class="ms-3">
                                    <div HJSuppress class="lead-name fw-semibold">{{ lead.lastName }} {{lead.firstName}}</div>
                                    <div><a HJSuppress href="mailto:{{ lead.email }}" class="lead-email">{{ lead.email }}</a></div>
                                    <div HJSuppress class="lead-phone">{{ lead.phoneNumber }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>